import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NayaxMachineConfig from '../components/NayaxMachineConfig';
import { useMachineByUuid } from '../hooks/useMachineByUuid';
import { ArrowLeft } from 'lucide-react';

const PaymentSettings: React.FC = () => {
    const { machineUuid } = useParams();
    const navigate = useNavigate();
    const { machine, isLoading } = useMachineByUuid(machineUuid);

    if (isLoading) {
        return <div className="p-6 text-center">Loading machine...</div>;
    }

    if (!machine) {
        return (
            <div className="p-6 text-center">
                <p className="text-gray-600">Machine not found.</p>
                <button
                    onClick={() => navigate('/lockers')}
                    className="mt-4 text-indigo-600 hover:text-indigo-800"
                >
                    Back to Lockers
                </button>
            </div>
        );
    }

    return (
        <div className="p-6">
            <div className="mb-6">
                <button
                    onClick={() => navigate('/lockers')}
                    className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors mb-4"
                    data-testid="back-to-lockers"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Back to Lockers
                </button>
                <h1 className="text-2xl font-bold text-gray-900">
                    Payment Settings: {machine.name}
                </h1>
            </div>

            <NayaxMachineConfig
                machine={machine}
                onConfigSaved={() => {
                    // Machine data will be refreshed on next navigation
                }}
            />
        </div>
    );
};

export default PaymentSettings;
